import SectionHeading from "./SectionHeading";
import { capabilities } from "@/mocks/content";

export default function Capabilities() {
  return (
    <section id="recursos" className="bg-background-50 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Ecossistema"
          title="Muito mais que um cardápio."
          subtitle="Um ecossistema criado para a operação do restaurante — do desejo do cliente ao caixa."
        />

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {capabilities.map((card, i) => (
            <article
              key={card.title}
              className="reveal group flex flex-col rounded-2xl border border-background-200 bg-background-100 p-7 transition-colors hover:border-primary-300 md:p-8"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-foreground-950">
                <i className={`${card.icon} text-2xl`} aria-hidden="true" />
              </span>

              {card.tag && (
                <span className="mt-5 w-fit rounded-full bg-accent-100 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-accent-700">
                  {card.tag}
                </span>
              )}

              <h3 className="mt-5 font-heading text-lg font-bold leading-snug text-foreground-950">
                {card.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {card.text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}